"use client";

import Link from "next/link";
import {useTranslation} from "react-i18next";
import {Permissions, RoleData} from "@/enums/user";
import {usePermissions} from "@/hooks/usePermissions";
import {canAccessNavItem} from "@/utils/authz/navAccess";
import {CREATE_OR_UPDATE_LEVELS} from "@/utils/authz/routeGates";

const KNOWLEDGE_FILES_NAV = {
   dataType: RoleData.Knowledge,
   additionalDataTypes: [RoleData.Agent, RoleData.Settings],
   levels: CREATE_OR_UPDATE_LEVELS,
} as const;

export function canShowMemoryKnowledgeBaseLink(
   canAccessAny: (dataTypes: readonly RoleData[], level: Permissions) => boolean
): boolean {
   return canAccessNavItem(KNOWLEDGE_FILES_NAV, canAccessAny);
}

export default function MemoryKnowledgeBaseLink() {
   const {t} = useTranslation("ask");
   const {canAccessAny} = usePermissions();
   if (!canShowMemoryKnowledgeBaseLink(canAccessAny)) {
      return null;
   }
   return (
      <Link
         href="/knowledge/files"
         className="text-primary underline underline-offset-2"
      >
         {t("memory.knowledgeBaseLink")}
      </Link>
   );
}
